
// src/pages/BranchMaster.jsx
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaEdit, FaTrash } from "react-icons/fa";
import {
  addBranch,
  getBranches,
  updateBranch,
  deleteBranch,
} from "../redux/slices/branchSlice";
import "../assets/BranchMaster.css";

const initialForm = {
  name: "",
  code: "",
  address: "",
  city: "",
  state: "",
  country: "",
  phone: "",
  SuperAdminId: localStorage.getItem("adminuserId"),
};

const BranchMaster = () => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState(initialForm);
  const [isEditMode, setIsEditMode] = useState(false);
  const [errors, setErrors] = useState({});
  const [page, setPage] = useState(1);
  const [limit] = useState(5); // ✅ show 5 branches per page

  const { branches, totalRecords, loading, error } = useSelector(
    (state) => state.branch
  );

  const totalPages = Math.ceil(totalRecords / limit);

  useEffect(() => {
    dispatch(getBranches({ page, limit }));
  }, [dispatch, page, limit]);



useEffect(() => {
  const adminId = localStorage.getItem("adminuserId");
  setFormData((prev) => ({ ...prev, SuperAdminId: adminId || "" }));
}, []);


  // console.log("Branches from Redux:", branches);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedValue = value;
    // if (name === "code") updatedValue = value.replace(/\D/g, "").slice(0, 6);
    if (name === "code") updatedValue = value.replace(/[^a-zA-Z0-9]/g, "").toUpperCase().slice(0, 6);
    if (name === "phone") updatedValue = value.replace(/\D/g, "").slice(0, 10);
    setFormData({ ...formData, [name]: updatedValue });
    setErrors({ ...errors, [name]: "" });
  };

  const validate = () => {
    let newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.code) newErrors.code = "Code is required";
    if (!formData.phone) newErrors.phone = "Phone number is required";
    else if (formData.phone.length < 10)
      newErrors.phone = "Phone must be 10 digits";
    return newErrors;
  };

 

  const saveBranch = async () => {
  try {
    const newErrors = validate();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    // ✅ Ensure SuperAdminId is always set from localStorage
    const branchData = {
      ...formData,
      SuperAdminId: localStorage.getItem("adminuserId") || "",
    };

    let res;
    if (isEditMode) {
      res = await dispatch(updateBranch(branchData));
    } else {
      res = await dispatch(addBranch(branchData));
    }

    if (res.meta.requestStatus === "fulfilled") {
      alert(`✅ Branch ${isEditMode ? "updated" : "created"} successfully`);
      setFormData({
        name: "",
        code: "",
        address: "",
        city: "",
        state: "",
        country: "",
        phone: "",
        SuperAdminId: localStorage.getItem("adminuserId") || "",
      });
      setIsEditMode(false);
      await dispatch(getBranches({ page, limit }));
    } else {
      const errorMsg =
        res.payload || res.error?.message || "Something went wrong!";
      alert("❌ " + errorMsg);
    }
  } catch (err) {
    console.error("Save Branch Error:", err);
    alert("❌ Unexpected error: " + err.message);
  }
};


  const handleEdit = (branch) => {
    setFormData(branch);
    setIsEditMode(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this branch?")) {
      const res = await dispatch(deleteBranch(id));
      if (res.meta.requestStatus === "fulfilled") {
        alert("🗑️ Branch deleted");
        dispatch(getBranches({ page, limit }));
      } else {
        alert("❌ " + res.payload);
      }
    }
  };

  const fields = [
    { key: "name", label: "Branch Name" },
    { key: "code", label: "Branch Code" },
    { key: "address", label: "Branch Address" },
    { key: "city", label: "Branch City" },
    { key: "state", label: "Branch State" },
   /* { key: "country", label: "Branch Country" }, */
    { key: "phone", label: "Phone Number" },
  ];

  return (
    <div className="BranchMaster-container">
      <h2>Branch Registration</h2>
      <div className="BranchMaster-form-container">
      <div className="BranchMaster-form">
        {fields.map(({ key, label }) => (
          <div key={key} className="BranchMaster-form-group">
            <label>{label}</label>
            <input
              type="text"
              name={key}
              value={formData[key]}
              onChange={handleChange}
              placeholder={`Enter ${label}`}
            />
            {errors[key] && <span className="error-text">{errors[key]}</span>}
          </div>
        ))}

      </div>
      <div className="branchMaster-create-btn">
        <button onClick={saveBranch} disabled={loading} >
          {loading
            ? "Processing..."
            : isEditMode
            ? "Update Branch"
            : "Create Branch"}
        </button>
      </div>
      </div>

      <h2>Branch Report (Total: {totalRecords})</h2>
      {error && <p className="BranchMaster-error">{error}</p>}

      <div className="BranchMaster-table-wrapper">
        <table className="BranchMaster-table">
          <thead>
            <tr>
              <th>S.N</th>
              <th>Code</th>
              <th>Name</th>
              <th>Address</th>
              <th>City</th>
              <th>State</th>
              <th>Country</th>
              <th>Phone</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {loading && (
              <tr>
                <td colSpan="8">Loading...</td>
              </tr>
            )}
            {!loading && Array.isArray(branches) && branches.length > 0 ? (
              branches.map((branch, index) => (
                <tr key={branch?.id || index}>
                  <td>{(page - 1) * limit + index + 1}</td>
                  <td>{branch?.code ||"N/A"}</td>
                  <td>{branch?.name ||"N/A"}</td>
                  <td>{branch?.address ||"N/A"}</td>
                  <td>{branch?.city ||"N/A"}</td>
                  <td>{branch?.state ||"N/A"}</td>
                  <td>{branch?.country ||"N/A"}</td>
                  <td>{branch?.phone ||"N/A"}</td>
                  <td>
                    <button className="LoanSchemeEditBtn" onClick={() => handleEdit(branch)}>
                      <FaEdit style={{ marginRight: "5px" }} /> 
                    </button>
                    <button className="LoanSchemeDeleteBtn" onClick={() => handleDelete(branch?.id)}>
                      <FaTrash style={{ marginRight: "5px" }} /> 
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              !loading && (
                <tr>
                  <td colSpan="8">No branches available</td>
                </tr>
              )
            )}
          </tbody>
        </table>
      </div>

      {/* ✅ Pagination Controls */}
      {totalPages > 1 && (
        <div className="pagination">
          <button
            onClick={() => setPage((p) => Math.max(p - 1, 1))}
            disabled={page === 1}
          >
            Prev
          </button>

          {/* {[...Array(totalPages)].map((_, i) => (
            <button
              key={i}
              className={page === i + 1 ? "active" : ""}
              onClick={() => setPage(i + 1)}
            >
              {i + 1}
            </button>
          ))} */}
          <div>Page {page} of {totalPages}</div>

          <button
            onClick={() => setPage((p) => Math.min(p + 1, totalPages))}
            disabled={page === totalPages}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default BranchMaster;
